module.exports = __webpack_public_path__ + "static/media/5a.545c9b91.png";